import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ComentarioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='COMENTARIO' htmlFor='input-comentario-documento' md={3} />
      <Col md={9}>
        <Field name='comentario'>
          {({ field }) => (
            <Form.TextArea
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-comentario-documento'
              placeholder='Comentario opcional ...'
              rows={2}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ComentarioFormGroup)
